import Vue from 'vue';
import VueFlags from '@growthbunker/vueflags';

Vue.use(VueFlags, { iconPath: '/img/flags' });
